<template>
  <div class="flex grow" data-test-id="layout-default">
    <v-app-bar
      v-if="!mdAndUp"
      flat
      density="comfortable"
      scroll-behavior="elevate"
      :scroll-threshold="50"
    >
      <v-app-bar-nav-icon
        data-test-id="menu-toggle-button"
        class="mr-1"
        @click.stop="drawerStore.isOpen = !drawerStore.isOpen"
      />
      <router-link
        data-test-id="menu-logo"
        class="flex items-center gap-2.5"
        to="/"
      >
        <img alt="" :src="logoIcon" class="size-8" />
        <div class="flex min-w-0 flex-col leading-tight">
          <span class="text-sm font-semibold text-grey-900">KINNOVIS</span>
          <span class="text-xs text-grey-600">Manager</span>
        </div>
      </router-link>
    </v-app-bar>

    <AppMainMenu v-model:open="drawerStore.isOpen" />

    <v-main app class="content">
      <div class="raised-panel">
        <AppMigrationBlockedBanner />
        <router-view />
      </div>
    </v-main>

    <AppDevChromeToggle />
  </div>
</template>

<script lang="ts" setup>
import logoIcon from '@manager/assets/logos/kinnovis-icon.svg';
import AppDevChromeToggle from '@manager/modules/app/components/AppDevChromeToggle.vue';
import AppMainMenu from '@manager/modules/app/components/AppMainMenu.vue';
import AppMigrationBlockedBanner from '@manager/modules/app/components/AppMigrationBlockedBanner.vue';
import { useNavigationDrawerStore } from '@manager/store/navigation-drawer-store';
import { onMounted } from 'vue';
import { useDisplay } from 'vuetify';

const { mdAndUp } = useDisplay();
const drawerStore = useNavigationDrawerStore();

// On mobile, drawer is overlay — start closed regardless of persisted state.
onMounted(() => {
  if (!mdAndUp.value) drawerStore.isOpen = false;
});
</script>

<style lang="scss">
.v-app-bar.v-toolbar {
  @apply bg-app-sidebar/30;
  backdrop-filter: blur(8px) saturate(180%);
}

.v-main {
  @apply bg-app-sidebar;
}

.raised-panel {
  @apply bg-white;
  border: 1px solid theme('colors.grey.200');
  border-radius: 12px;
  box-shadow: 0 2px 12px -4px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  margin: 12px;
  min-height: calc(100% - 24px);
  // `clip` (not `hidden`) clips child content to the rounded corners without
  // making the panel a scroll container — preserves descendant `position: sticky`.
  overflow: clip;
}

@media (max-width: 639px) {
  .v-app-bar.v-toolbar {
    @apply border-b border-app-separator bg-app-sidebar;
    backdrop-filter: none;
  }

  .v-main {
    @apply bg-white;
  }

  .raised-panel {
    border: none;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    min-height: 100%;
  }
}
</style>
